import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Companies } from "../models/companies.model";

@Injectable({
  providedIn: "root"
})
export class CompaniesService {
  constructor(private http: HttpClient) { }

  getCurrentUser() {
    let getUserData = localStorage.getItem("currentUser");
    let bearer = JSON.parse(getUserData);
    return bearer.token;
  }

  private optionsHeaderFile = {
    headers: new HttpHeaders({
      "origin": "https://app.teddy360.com.br",
      "x-tenant-id": "1",
      "tenantUuuid": "51105888-88bc-4795-98c2-73c1de5a7c25",
      Authorization: "Bearer " + this.getCurrentUser()
    })
  };

  token = {
    headers: new HttpHeaders({
      "Content-Type": "application/json; charset=UTF-8",
      Authorization: "Bearer " + this.getCurrentUser()
    })
  };

  async createCompanie(data: Companies) {
    const response = await this.http.post<Companies>("/company", data, this.token).toPromise();
    return response;
  }

  getCompanieById(id: string) {
    return this.http.get<any>(`/company/${id}`, this.token);
  }

  async editCompanie(data: Companies, id: string) {
    const response = await this.http.patch<Companies>(`/company/${id}`, data, this.token).toPromise();
    return response;
  }

  editCompany(data: any, id: string) {
    return this.http.put<Companies>(`/company/${id}/edit`, data, this.optionsHeaderFile);
  }
}
